import { gql } from '@apollo/client';

export const CREATE_PROCEEDING_MUTATION = gql`
  mutation CreateProceeding($input: NewProceeding) {
    createProceeding(input: $input) {
      chcReceivedDate
      id
      proceedingId
      description        
    }
  }
`;

export const formatOptions = [
  { value: 'Oral', label: 'Oral' },
  { value: 'Written', label: 'Written' },
  { value: 'Electronic', label: 'Electronic' },
];